module.exports = __webpack_public_path__ + "img/mobile-main-image.15c1d4a3.png";